var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "14",
        "height": "14",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('path', {
      attrs: {
        "d": "M7 0a7 7 0 00-7 7 7 7 0 007 7 7 7 0 007-7 7 7 0 00-7-7zm4.253 11.253a5.984 5.984 0 01-1.912 1.29A5.958 5.958 0 017 13.016a5.98 5.98 0 01-4.253-1.761 5.984 5.984 0 01-1.29-1.913A5.97 5.97 0 01.984 7a5.98 5.98 0 011.761-4.253 5.984 5.984 0 011.913-1.29A5.97 5.97 0 017 .984a5.98 5.98 0 014.253 1.761 5.984 5.984 0 011.29 1.913A5.97 5.97 0 0113.016 7a5.98 5.98 0 01-1.763 4.253zm-1.245-4.738H7.499v-2.51a.492.492 0 10-.984 0v2.51H3.992a.492.492 0 100 .984h2.523v2.495a.492.492 0 10.984 0V7.5h2.509a.492.492 0 100-.984z",
        "fill": "var(--mainColor)",
        "fill-rule": "evenodd"
      }
    })]));
  }
};